import React from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { returnMainId } from 'src/utitlity'
import HeaderTeamSubNav from 'src/components/header/subheaderfeedbackchart'
import TeamFeedbackSubNav from './textFeedbackHeader'
import Header from './'
import HeaderTeamSubNavNew from 'src/components/header/teamSubNavNew'
import HeaderCompanySubNavNew from 'src/components/header/headerCompanySubNav'
import HeaderUserSubNav from 'src/components/header/userSettingsSubHeader'
import FeedbackInputSubNav from './feedbackInputSubNav'
import { RootState } from 'src/configureStore'
import { connect, ConnectedProps } from 'react-redux'




const mapStateToProps = (state: RootState) => ({
  user: state.authReducer.user,
  selectedTeam: state.teamReducer.selectedTeam
})



interface Props {
  children?: React.ReactChild | React.ReactChild[]
}
const connector = connect(mapStateToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
const returnSubNav = (pathname: string, isAdmin?: boolean): any => {
  if (!isAdmin) return null
  if (pathname === '/team/feedbackRequest') {
    return null
  }
  if (
    (pathname.includes('/data/') && pathname.includes('/team/')) ||
    (pathname.includes('/giveFeedback') && pathname.includes('/team/'))
  ) {
    return <HeaderTeamSubNav level1={'feedchart'} />
  }
  if (
    pathname === '/user/generalSettings' ||
    pathname === '/user/teamSettings'
  ) {
    return <HeaderUserSubNav />
  }

  if (pathname.includes('/team/')) {
    if (pathname === '/team/teamFeedback') return <TeamFeedbackSubNav />
    return (
      <>
        <HeaderTeamSubNavNew />
        {pathname.includes('/settings/feedbackInput') && (
          <FeedbackInputSubNav />
        )}
      </>
    )
  }
  if (pathname.includes('/company/')) {
    return <HeaderCompanySubNavNew />
  }

  return null
}

const authClassString = (pathname: string): any => {
  if (pathname == '/') {
    return 'main'
    // return 'auth'
  } else {
    return 'main'
  }
}

const MainComponent = (props: Props & PropsFromRedux) => {
  const { children, user, selectedTeam } = props
  const { pathname } = useLocation()
  const subnav = returnSubNav(pathname, selectedTeam?.isAdmin)
  const id = returnMainId(pathname)




  return (
    <main id={id} className={authClassString(pathname)}>
      {/* {user && (
        <Header type={pathname === '/home' ? 'white' : undefined}>
          {subnav}
        </Header>
      )} */}

      { !pathname.includes('/createAccount/step-01') && !pathname.includes('/createAccount/step-02') && !pathname.includes('/resetPassword') && pathname !== '/' && (
        <Header type={pathname === '/home' ? 'white' : undefined}>
          {subnav}
        </Header>
      )}
      {children}
    </main>
  )
}

export default connector(MainComponent)
